import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-head box-shadow bg-white d-md-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "bg-transparent text-primary transition p-0 border-0"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-search-interface-symbol" })
], -1)
const _hoisted_4 = { class: "d-sm-flex align-items-center" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-plus position-relative ms-5 fs-12" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Faire un approvisionnement", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("button", {
  class: "default-outline-btn position-relative transition fw-medium text-black pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-30 pe-md-30 rounded-1 bg-transparent fs-md-15 fs-lg-16 d-inline-block mt-10 mt-md-0",
  type: "button"
}, [
  /*#__PURE__*/_createTextVNode(" Export "),
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-file-1 position-relative ms-5 top-2 fs-15" })
], -1)
const _hoisted_8 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_9 = { class: "table-responsive" }
const _hoisted_10 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
    }, " # "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " date "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
    }, " Reference "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " montant "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
    }, " Actions ")
  ])
], -1)
const _hoisted_12 = { class: "shadow-none lh-1 fw-medium text-paragraph" }
const _hoisted_13 = { class: "shadow-none lh-1 fw-medium text-paragraph" }
const _hoisted_14 = { class: "shadow-none lh-1 fw-medium text-paragraph" }
const _hoisted_15 = { class: "shadow-none lh-1 fw-medium text-paragraph" }
const _hoisted_16 = { class: "shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0" }
const _hoisted_17 = { class: "dropdown" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", {
  class: "badge text-white bg-primary fs-15 dropdown-toggle",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}, [
  /*#__PURE__*/_createTextVNode(" Actions "),
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-chevron-2 position-relative ms-5 top-2 fs-15" })
], -1)
const _hoisted_19 = { class: "dropdown-menu" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-eye lh-1 me-8 position-relative top-1" }, null, -1)
const _hoisted_22 = ["onClick"]
const _hoisted_23 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-delete lh-1 me-8 position-relative top-1" }, null, -1)
const _hoisted_24 = { class: "pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center" }
const _hoisted_25 = {
  class: "modal fade createNewModal",
  id: "MyModal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_26 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_27 = { class: "modal-content p-15 p-md-40" }
const _hoisted_28 = { class: "modal-header d-block ps-0 pe-0 pt-0 pb-15 pb-md-25" }
const _hoisted_29 = { class: "modal-title fw-bold text-black" }
const _hoisted_30 = { class: "modal-body ps-0 pe-0 pb-0 pt-15 pt-md-25" }
const _hoisted_31 = { class: "table-responsive" }
const _hoisted_32 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_33 = { key: 0 }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("th", null, " DATE ", -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("th", null, " MONTANT ", -1)
const _hoisted_36 = { key: 0 }
const _hoisted_37 = { class: "bg-primary text-white p-10 mt-10" }
const _hoisted_38 = { class: "modal-title fw-bold text-white" }
const _hoisted_39 = {
  class: "table text-nowrap align-middle mb-0",
  style: {"width":"100%"}
}
const _hoisted_40 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", null, " # "),
  /*#__PURE__*/_createElementVNode("th", null, " PRODUIT "),
  /*#__PURE__*/_createElementVNode("th", null, " QTE "),
  /*#__PURE__*/_createElementVNode("th", null, " PRIX ACHAT ")
], -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close shadow-none",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_PaginationComponent = _resolveComponent("PaginationComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("form", {
          class: "search-box position-relative",
          onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.rechercher && _ctx.rechercher(...args)), ["prevent"]))
        }, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchTerm) = $event)),
            onKeyup: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.rechercher && _ctx.rechercher(...args))),
            class: "form-control shadow-none text-black rounded-0 border-0",
            placeholder: "Rechercher un approvisionnement"
          }, null, 544), [
            [_vModelText, _ctx.searchTerm]
          ]),
          _hoisted_3
        ], 32),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_router_link, {
            to: "/Ajout-Approvisionnement",
            class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none"
          }, {
            default: _withCtx(() => [
              _hoisted_5,
              _hoisted_6
            ]),
            _: 1
          }),
          _hoisted_7
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("table", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.elements, (vente, index) => {
                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                  _createElementVNode("td", _hoisted_12, _toDisplayString(vente.id), 1),
                  _createElementVNode("td", _hoisted_13, _toDisplayString(_ctx.format_date(vente.dateAppro)), 1),
                  _createElementVNode("td", _hoisted_14, _toDisplayString(vente.reference), 1),
                  _createElementVNode("td", _hoisted_15, _toDisplayString(vente.montant), 1),
                  _createElementVNode("td", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      _hoisted_18,
                      _createElementVNode("ul", _hoisted_19, [
                        _createElementVNode("li", null, [
                          _createElementVNode("a", {
                            class: "dropdown-item d-flex align-items-center",
                            href: "javascript:void(0);",
                            "data-bs-toggle": "modal",
                            "data-bs-target": "#MyModal",
                            onClick: ($event: any) => (_ctx.detail(vente.id))
                          }, [
                            _hoisted_21,
                            _createTextVNode(" Détail ")
                          ], 8, _hoisted_20)
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("a", {
                            class: "dropdown-item d-flex align-items-center",
                            href: "javascript:void(0);",
                            onClick: ($event: any) => (_ctx.suppression(vente.id,_ctx.elements,'approvisionnement','cette approvisionnement ?'))
                          }, [
                            _hoisted_23,
                            _createTextVNode(" Annuler cet approvisionnement ")
                          ], 8, _hoisted_22)
                        ])
                      ])
                    ])
                  ])
                ]))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_24, [
          _createVNode(_component_PaginationComponent, {
            page: _ctx.page,
            totalPages: _ctx.totalPages,
            totalElements: _ctx.totalElements,
            limit: _ctx.limit,
            onPaginate: _ctx.handlePaginate
          }, null, 8, ["page", "totalPages", "totalElements", "limit", "onPaginate"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_25, [
      _createElementVNode("div", _hoisted_26, [
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("h5", _hoisted_29, "Détails - " + _toDisplayString((_ctx.element?.reference) ? _ctx.element.reference : ""), 1)
          ]),
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("table", _hoisted_32, [
                (_ctx.element)
                  ? (_openBlock(), _createElementBlock("tbody", _hoisted_33, [
                      _createElementVNode("tr", null, [
                        _hoisted_34,
                        _createElementVNode("td", null, _toDisplayString((_ctx.element.dateAppro) ? _ctx.formatDate(_ctx.element.dateAppro) : ""), 1),
                        _hoisted_35,
                        _createElementVNode("td", null, _toDisplayString((_ctx.element.montant) ? _ctx.formatMontant(_ctx.element.montant) : ""), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.element)
                ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.element.approMags, (mag, index) => {
                      return (_openBlock(), _createElementBlock("div", { key: index }, [
                        _createElementVNode("div", _hoisted_37, [
                          _createElementVNode("h5", _hoisted_38, "Magasin - " + _toDisplayString((mag.magasin.libelle)), 1)
                        ]),
                        _createElementVNode("table", _hoisted_39, [
                          _createElementVNode("tbody", null, [
                            _hoisted_40,
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mag.approMagProdConds, (prod, indexx) => {
                              return (_openBlock(), _createElementBlock("tr", { key: indexx }, [
                                _createElementVNode("td", null, _toDisplayString(prod.id), 1),
                                _createElementVNode("td", null, _toDisplayString(prod.produitConditionnement?.nomComplet), 1),
                                _createElementVNode("td", null, _toDisplayString(prod.qteAppro), 1),
                                _createElementVNode("td", null, _toDisplayString(prod.prixAchat), 1)
                              ]))
                            }), 128))
                          ])
                        ])
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _hoisted_41
        ])
      ])
    ])
  ], 64))
}